import { trackerStages, trackerSteps } from 'src/components/TransactionSummary/constants';
import * as yup from 'yup';

export const moveTaskValidationSchema = yup.object().shape({
	step: yup.string().required('This field is required').oneOf(trackerSteps, 'Step must be valid tracker step'),
	stage: yup.string().required('This field is required').oneOf(trackerStages, 'Step must be valid tracker stage'),
});
